<div class="main-content" [class.loading-section]="isUpdating$ | async">
  <div class="d-flex align-items-center gap-3 mb-3">
    <h6 class="mb-0" i18n>Website Details</h6>
    <div class="flex-fill"></div>
    <button (click)="onSave(form)" type="button" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info">
      <span class="cs-icon cs-icon-save"></span> <ng-container i18n>Save</ng-container>
    </button>
  </div>
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="container-box details-box">
      <div class="box-body">
        <div class="d-flex align-items-center rounded-top overflow-hidden">
          <h6 class="section-title flex-1 border-top-0" i18n>Website Information</h6>
          <h6 class="section-title text-right flex-1 border-top-0">
            <ng-container i18n>Last published:</ng-container> {{ website.lastPublished | epoch }}
          </h6>
        </div>
        <div class="row px-3">
          <div class="col-6">
            <mat-form-field2 class="mat-block">
              <input
                type="text"
                matInput
                required
                i18n-placeholder
                placeholder="Website Title"
                formControlName="title"
              />
              <mat-hint align="end">{{ form.get('title').value.length || 0 }}/50</mat-hint>
              <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('required')">
                <ng-container i18n>Website Title is required</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('minlength')">
                <ng-container i18n>Website Title must be at least 2 characters long</ng-container>
              </mat-error>
              <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('maxlength')">
                <ng-container i18n>Website Title must be at most 50 characters long</ng-container>
              </mat-error>
            </mat-form-field2>
            <div class="d-flex gap-3">
              <mat-form-field2 class="mat-block">
                <input type="text" matInput required i18n-placeholder placeholder="Domain" formControlName="domain" />
                <a href="javascript:;" (click)="onEditDomain()" class="btn btn-sm text-info" matSuffix>
                  <i class="far fa-edit"></i>
                </a>
              </mat-form-field2>
              <app-website-custom-domain-ssl
                *ngIf="isCustomDomain"
                [website]="website"
                class="align-input-row-end"
              ></app-website-custom-domain-ssl>
            </div>
            <mat-form-field2>
              <app-select
                [items]="templates"
                formControlName="template"
                required
                bindLabel="title"
                bindValue="name"
                i18n-placeholder
                placeholder="Select Template"
                matTooltip="Select the template to use with your website. These templates support {{
                  website.rentals.length <= 1 ? 'a single rental' : 'multiple rentals'
                }}. This is based on the number of selected rentals."
                matTooltipPosition="above"
              >
                <ng-template selectItem let-item="item" let-index="index">
                  <div [matTooltip]="tooltipsForTemplate[item.name]" matTooltipPosition="right">
                    {{ item.title }}
                  </div>
                </ng-template>
              </app-select>
              <mat-error *ngIf="form.get('template').touched && form.get('template').hasError('required')">
                <ng-container i18n>Template is required</ng-container>
              </mat-error>
            </mat-form-field2>

            <mat-form-field2 class="mat-block">
              <input
                matInput
                formControlName="logoRedirectUrl"
                i18n-placeholder
                placeholder="Logo Redirect URL or Path"
              />
              <mat-hint i18n>Use /about or https://example.com. Leave blank to use the homepage.</mat-hint>
              <mat-error *ngIf="form.get('logoRedirectUrl').hasError('logoRedirectUrl')" i18n>
                Enter a site path starting with / or a valid HTTP(S) URL.
              </mat-error>
            </mat-form-field2>
            <app-select-search
              [items]="rateCategories"
              [ctrl]="form.get('rateCategory')"
              [multiple]="false"
              bindValue="value"
              bindLabel="label"
              [inline]="false"
              i18n-placeholder
              placeholder="Rate Category"
              i18n-matTooltip
              matTooltip="Select the rate category you want displayed on your website."
              matTooltipPosition="above"
            >
              <ng-container class="error-container">
                <mat-error i18n> Rate Category is required </mat-error>
              </ng-container>
            </app-select-search>
            <app-form-switch
              formControlName="engine_enabled"
              class="mt-primary"
              i18n-matTooltip
              matTooltip="Allow guests to book via their credit cards on this website. You must have a Stripe payment gateway connected. This will not automatically bill the guests. Make sure you create an invoice for each inquiry that is created from your website."
              matTooltipPosition="above"
            >
              <ng-container i18n>Enable Online Bookings.</ng-container> ({{
                form.get('engine_enabled').value ? 'Enable' : 'Disabled'
              }})
            </app-form-switch>
          </div>
          <div class="col-6">
            <mat-form-field2 class="mat-block">
              <textarea
                name="description"
                matInput
                i18n-placeholder
                placeholder="Brief Description"
                formControlName="description"
                rows="18"
                maxlength="1000"
                cdkTextareaAutosize
              ></textarea>
              <mat-hint align="end">{{ form.get('description').value.length || 0 }}/1000</mat-hint>
            </mat-form-field2>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
